import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";
import { Injectable } from "@angular/core";

@Injectable()
export class MaterialIconService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) { }
  init() {
    this.matIconRegistry.addSvgIcon(
      "accessibility_new",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/accessibility_new.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "add",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/add.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "add_alert",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/add_alert.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "add_box",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/add_box.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "add_circle",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/add_circle.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "add_circle_outline",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/add_circle_outline.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "arrow_back",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/arrow_back.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "arrow_forward",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/arrow_forward.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "art_track",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/art_track.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "assessment",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/assessment.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "assignment",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/assignment.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "assignment_ind",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/assignment_ind.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "assignment_return",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/assignment_return.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "attach_file",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/attach_file.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "backup",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/backup.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "beach_access",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/beach_access.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "build",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/build.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "cached",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/cached.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "calculate",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/calculate.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "caliper",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/caliper2.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "caliper-white",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/caliper_white.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "call",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/call.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "cake",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/cake.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "check",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/check.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "clear",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/clear.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "close",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/close.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "cloud_download",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/cloud_download.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "cloud_upload",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/cloud_upload.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "create",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/create.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "delete",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/delete.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "done",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/done.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "done_all",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/done_all.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "edit",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/edit.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "error",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/error.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "event",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/event.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "exit_to_app",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/exit_to_app.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "expand_less",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/expand_less.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "expand_more",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/expand_more.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "file_copy",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/file_copy.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "filter_list",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/filter_list.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "filter_none",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/filter_none.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "find_in_page",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/find_in_page.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "fitness_center",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/fitness_center.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "food-apple",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/food-apple.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "forward",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/forward.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "get_app",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/get_app.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "group",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/group.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "home",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/home.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "info",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/info.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "keyboard_arrow_down",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/keyboard_arrow_down.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "keyboard_arrow_left",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/keyboard_arrow_left.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "keyboard_arrow_right",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/keyboard_arrow_right.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "language",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/language.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "list",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/list.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "menu",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/menu.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "mail_outline",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/mail_outline.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "monitor_weight",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/monitor_weight.svg")
    );   
    this.matIconRegistry.addSvgIcon(
      "more_vert",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/more_vert.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "navigate_before",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/navigate_before.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "navigate_next",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/navigate_next.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "notification_important",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/notification_important.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "notifications",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/notifications.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "open_with",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/open_with.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "pan_tool",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/pan_tool.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "pause_circle_outline",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/pause_circle_outline.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "perm_data_setting",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/perm_data_setting.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "person",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/person.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "pin_drop",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/pin_drop.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "play_circle_outline",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/play_circle_outline.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "preview",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/preview.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "redo",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/redo.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "refresh",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/refresh.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "remove",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/remove.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "remove_circle_outline",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/remove_circle_outline.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "replay",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/replay.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/report.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "save",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/save.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "save_alt",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/save_alt.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "search",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/search.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "set_meal",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/set_meal.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "send",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/send.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "shopping_cart",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/shopping_cart.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "sort",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/sort.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "square_foot",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/square_foot.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "swap_horiz",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/swap_horiz.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "swap_vert",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/swap_vert.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "thumb_down",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/thumb_down.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "thumb_up",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/thumb_up.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "timer",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/timer.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "touch_app",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/touch_app.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "track_changes",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/track_changes.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "trending_down",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/trending_down.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "update",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/update.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "view_list",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/view_list.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "visibility",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/visibility.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "visibility_off",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/visibility_off.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "warning",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/material-icons/warning.svg")
    );
  }
}
